import React from 'react'

export default function FullscreenViewerHeader({ title, onclose }) {
  return (
    <div className="processing-page-pdf-form-full-screen-header">
      <div style={{ padding: '6px 0 12px 0' }} className="dome-d-flex dome-justify-between">
        <span className="dome-h3 dome-color-dark-grey dome-text-w500">{title}</span>
        <span onClick={onclose} className="dome-cursor-pointer">
          <i className="fa-regular fa-xmark dome-color-dark-grey"></i>
        </span>
      </div>
    </div>
  )
}
